import React from "react";
import { Link } from "react-router-dom";
// import "./Footer.css"
export default function Footer() {
  return (
    <>
      <div className=" w-full uppercase h-full py-2 bg-no-repeat bg-cover bg-fixed justify-between text-[#ffff] "
        Style="background-image: url('./image/footer1.gif')"
      >
        <div className="container pt-4">

          <div className="col-md-6 w-100 mt-20 p-4 section2 ">
            <div className="w-auto	py-2 ">
              <Link to="/">
                <h1 className="text-3xl font-bold ">
                  MsCube <span className=" text-[#ee2da4]">Tech</span>
                </h1>
              </Link>
              <h4 className=" text-xs font-bold py-2 hover:text-[#ee2da4]">TECH DEVElopers</h4>
              <p className="text-sm py-2 mr-4 ">  Discover what our on-demand cloud development teams can do for your bottom line today.</p>

            </div>

            <div className="w-50	py-2 ">
              <h4 className=" text-sm font-bold">COMPANY</h4>
              <ul className="text-sm">
                <br />
                <Link to='/our-service'>
                  <li className="p-1 hover:text-[#ee2da4]">SERVICES</li>
                </Link>
                <li className="p-1 hover:text-[#ee2da4]">BLOG</li>
                <Link to='/contact'>
                  <li className="p-1 hover:text-[#ee2da4]"> CONTACT US</li>
                </Link>
                <Link to="/about">
                  <p className="  p-1 hover:text-[#ee2da4] ">About us</p>
                </Link>
                <Link to="/faq">
                  <p className="  p-1 hover:text-[#ee2da4]">FAQ's</p>
                </Link>
              </ul>
            </div>
            <div className=" w-50 py-2">
              <h4 className=" text-sm font-bold">FOLLOW US</h4>
              <ul className="text-sm">
                <br />
                <Link to='https://www.linkedin.com/company/mscube-tech/'>
                  <li className="p-1 hover:text-[#ee2da4]">linkedin </li>
                </Link>
                <Link to='https://www.instagram.com/mscubetech/'>
                  <li className="p-1 hover:text-[#ee2da4]">instagram</li>
                </Link>
                <Link to='https://twitter.com/mscubetech'>
                  <li className="p-1 hover:text-[#ee2da4]">x - Twitter</li>
                </Link>
                <Link to='https://www.facebook.com/mscubetechs'>
                  <li className="p-1 hover:text-[#ee2da4]">facebook</li>
                </Link>
              </ul>
            </div>
            <div className="w-50 py-2	">
              <h4 className=" text-sm font-bold">services</h4>
              <ul className="text-sm">
                <br />
                <Link to='/Fullstack-web-development'>
                  <li className="p-1 hover:text-[#ee2da4]">Full web development</li></Link>
                <Link to='/product-design'> <li className="p-1 hover:text-[#ee2da4]">ui/ux design</li> </Link>
                <Link to='/App-Development'>
                  <li className="p-1 hover:text-[#ee2da4]">app development</li>
                </Link>
                <Link to='/our-service'>
                  <li className="p-1 hover:text-[#ee2da4]">wordpress </li>
                </Link>
                <Link to='/our-service'>
                  <li className="p-1 hover:text-[#ee2da4]">shopify</li>
                </Link>

              </ul>
            </div>
            <div className="w-50	py-2">
              <h4 className=" text-sm font-bold">address</h4>
              <ul className="text-sm">
                <br />
                <li className="p-1 hover:text-[#ee2da4]">Lahore, Pakistan</li>
                <li className="p-1 hover:text-[#ee2da4]">phone on: +92322383475</li>
                <Link to='mailto: musharafali494@gmail.com'>
                  <li className="p-1 hover:text-[#ee2da4]">e-mail: musharafali494@gmail.com</li>
                </Link>
              </ul>
            </div>

          </div>

        </div>

        <div className="w-100 font-bold justify-center text-center	 ">
          <p className="text-xs mt-20 text-center">
            ENGLISH | FRANCAIS | PORTUGUES
            <small>@ ALL RIGHTS RESERVED</small>
          </p>
        </div>

      </div >
    </>
  );
}
